import React from 'react'
import Reflux from 'reflux'
import {
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	Button
} from 'reactstrap'

import IngredientsTypesStore from '~/stores/ingredientsTypes.js'
import IngredientsTypesActions from '~/actions/ingredientsTypes.js'
import IngredientsTypesList from '~/modules/modals/ingredientsTypes/list.jsx'
import IngredientsTypesAdd from '~/modules/modals/ingredientsTypes/add.jsx'
import OnlyIfAuthorized from '~/modules/onlyIfAuthorized/index.jsx'


export default class RecipeIngredientsTypesModal extends Reflux.Component {
	constructor(props) {
		super(props)

		this.store = IngredientsTypesStore
	}

	render() {
		return (
			<OnlyIfAuthorized>
				<Modal
					size="lg"
					isOpen={this.state.showIngredientsTypesTypesModal === true}
				>
					<ModalHeader
						toggle={IngredientsTypesActions.hideModal}
					>
						Recipe Ingredient Types (Diced, Chopped, etc)
					</ModalHeader>
					<ModalBody>
						<IngredientsTypesAdd
							ingredientID={0}
						/>

					<IngredientsTypesList />
					</ModalBody>
					<ModalFooter>
						<Button
							onClick={IngredientsTypesActions.hideModal}
						>
							Close Ingredient Types
						</Button>
					</ModalFooter>
				</Modal>
			</OnlyIfAuthorized>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/modals/ingredientsTypes.jsx